'use client';

import { AppParametersContext } from '@app/app/_context/AppParametersContext/AppParametersContext';
import { AppParameters } from '@app/infrastructure/parameters/model/AppParameters';
import { ReactNode } from 'react';

interface Props {
    appParameters: AppParameters;
    children: ReactNode;
}

export function AppParametersContextProvider({ appParameters, children }: Props) {
    return <AppParametersContext.Provider value={appParameters}>{children}</AppParametersContext.Provider>;
}
